<template>
  <div class="yq-components">
    <div class="content">
      <div class="card-list" v-if="vStatus==0" element-loading-background="rgba(0, 0, 0, 0.1)" v-loading="dLoading">
        <template v-for="(item, index) in personList">
          <div class="yq-card-item" :key="index" @click="showMode(item)">
            <div class="equip-item-top">
              <el-col :span="6">
                <div class="equip-imag">

                    <template v-if="item.status == 0||item.status == 1||item.status == 2">
                      <div class="img-icon3">
                        <img :src="item.photoLink" alt />
                      </div>
                      <p class="state3" style="margin-top: 8px">
                        <span class="yuandian"></span>
                        <span>在库</span>
                      </p>
                    </template>

                   
                    <template v-if="item.status == 3">
                      <div class="img-icon3">
                        <img :src="item.photoLink" alt />
                      </div>
                      <p class="state3" style="margin-top: 8px">
                        <span class="yuandian"></span>
                        <span>管理员取出</span>
                      </p>
                    </template> 
                    <template v-if="item.status == 6||item.status == 4||item.status == 5">
                      <div class="img-icon2">
                        <img :src="item.photoLink" alt />
                      </div>
                      <p class="state2" style="margin-top: 8px">
                        <span class="yuandian"></span>
                        <span>借出</span>
                      </p>
                    </template>
                  
                  
                  </div>
              </el-col>
              <el-col :span="18">
                <div class="equip-detail">
                  <div class="items items-hidden">
                    <span>{{ item.instrumentName }}</span>
                  </div>
                  <div class="items tow-columns">
                    <div class="left_item">
                      <span>编号：</span>
                      <span>{{ item.serialNumber }}</span>
                    </div>
                    <div class="rigth_item">
                      <span>型号：</span>
                      <span>{{ item.pattern }}</span>
                    </div>
                  </div>
                  <div class="items tow-columns">
                    <div class="left_item">
                      <span>位置：</span>
                        <span v-if="item.address">{{ item.address }}</span>
                        <span v-else-if=" item.boxIndex ">格口{{ item.boxIndex }}</span>
                        <span v-else>{{ item.shelfName }}-{{ item.storeName }}</span> 
                    </div>
                    <div class="rigth_item" v-if="item.status == 4||item.status==5">
                      <span>借出人：</span>
                      <span>{{ item.borrower }}</span>
                    </div>
                  </div>
                  <div class="iconf-letf">
                    <span @click.stop="abnormalClick(item)">
                      <i style="font-size: 18px;" class="iconfont icon-weixiu"></i>
                    </span>
                    &nbsp;
                    <span @click.stop="maintainClick(item)">
                      <i style="font-size: 18px;" class="iconfont icon-baoyang"></i>
                    </span>
                    &nbsp;
                    <span @click.stop="testClick(item)">
                      <i style="font-size: 18px;" class="iconfont icon-jiandingdan"></i>
                    </span>
                    &nbsp;
                    <span @click.stop="exportClick(item)">
                      <i style="font-size: 18px;" class="iconfont icon-wendang"></i>
                    </span>
                    &nbsp;
                    <span @click.stop="editClick(item)">
                      <i style="font-size: 18px;" class="iconfont icon-bianji1"></i>
                    </span>
                    &nbsp; 
                    <span @click.stop="outPut(item)">
                      <i style="font-size: 18px;" class="el-icon-document-copy"></i>
                    </span>
                  </div>
                </div>
              </el-col>
            </div>
            <div class="equip-item-bottom">
              <div class="row-item">
                <div class="left_item1">
                  <span>厂家：</span>
                  <span>{{ item.factoryName }}</span>
                </div>
                <div class="right_item1">
                  <span>价钱：</span>
                  <span>{{ item.prize?item.prize:"暂无" }}</span>
                </div>
              </div>
              <div class="row-item">
                <div class="left_item2">
                  <span>出厂日期：</span>
                  <span>{{ item.produceTime }}</span>
                </div>
                <div class="right_item2">
                  <span>启用时间：</span>
                  <span>{{ item.startUpTime }}</span>
                </div>
              </div>
              <div class="row-item">
                <div class="left_item2">
                  <span>精度：</span>
                  <span>{{ item.precision }}</span>
                </div>
                <div class="rigth_item">
                  <span>检定有效期：</span>
                  <span>{{ item.validityEffectiveTime }}</span>
                </div>
              </div>
              <div class="row-item">
                <div class="left_item">
                  <span>量程：</span>
                  <span>{{ item.range }}</span>
                </div>
                <div class="rigth_item">
                  <span>保养有效期：</span>
                  <span>{{ item.maintenanceEffectiveTime }}</span>
                </div>
              </div>
              <div class="row-item dibu" @click.stop="statesChange(item)">
                <template v-if="item.states == 0">
                  <span class="state1">
                    <i class="iconfont icon-zhengchang"></i>
                    <span>正常</span>
                  </span>
                </template>
                <template v-if="item.states == 1">
                  <span class="state3">
                    <i class="iconfont icon-jiangji"></i>
                    <span>降级</span>
                  </span>
                </template>
                <template v-if="item.states == 2">
                  <span class="state2">
                    <i class="iconfont icon-tingyong_line"></i>
                    <span>停用</span>
                  </span>
                </template>
                <template v-if="item.states == 3">
                  <span class="state2">
                    <i class="iconfont icon-weixiu"></i>
                    <span>需维修</span>
                  </span>
                </template>
                <template v-if="item.states == 4">
                  <span class="state3">
                    <i class="iconfont icon-shebeijiandingshiyongren"></i>
                    <span>需检定</span>
                  </span>
                </template>
                <template v-if="item.states == 5">
                  <span class="state3">
                    <i class="iconfont icon-icon"></i>
                    <span>需保养</span>
                  </span>
                </template>
                <template v-if="item.states == 6">
                  <span class="state3">
                    <i class="iconfont icon-icon"></i>
                    <span>报废</span>
                  </span>
                </template>
                <template v-if="item.isNeedPower == 0 && item.isCharger">
                  <span class="state1" @click.stop="mandian">
                    <i class="iconfont icon-battery-full"></i>满电
                  </span>
                </template>
                <template v-if="item.isNeedPower == 1 && item.isCharger">
                  <span class="state3" @click.stop="recharge(item)">
                    <i class="iconfont icon-juxingcopy"></i>充电
                  </span>
                </template>
              
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="table-list sysTable-w" v-else>
        <el-table :row-key="getRowKeys" ref="multipleTable" @selection-change="handleSelectionChange"  :data="personList" height="740" element-loading-background="rgba(0, 0, 0, 0.1)" v-loading="dLoading" style="width: 100%">
          <el-table-column type="selection" width="55" :reserve-selection="true" />
          <el-table-column type="index" label="序号" align="center" width="80">
          </el-table-column>
          <el-table-column align="center" prop="instrumentName" label="仪器名称" show-overflow-tooltip min-width="200">
          </el-table-column>
          <el-table-column align="center" prop="serialNumber" label="编号" show-overflow-tooltip width="150">
          </el-table-column>
          <el-table-column align="center" prop="pattern" label="型号" show-overflow-tooltip width="150">
          </el-table-column>
          <el-table-column align="center"  label="资产类型" show-overflow-tooltip min-width="200">
                <template slot-scope="scope">
                  {{scope.row.assetType==1?'固定资产':scope.row.assetType==2?'非固定资产':'-'}}
                </template>
            </el-table-column>
        
          <el-table-column align="center" prop="prize" label="价钱" show-overflow-tooltip width="120">
          </el-table-column>
          <el-table-column align="center" prop="boxIndex" label="位置" width="120">
            <template slot-scope="scope">
                <template v-if="scope.row.address">
                  {{ scope.row.address }}
                </template>
                <template v-else-if="scope.row.boxIndex">
                  格口{{scope.row.boxIndex}}
                </template>
                <template v-else>
                  <span>{{ scope.row.shelfName }}-{{ scope.row.storeName }}</span>
                </template>
              </template>
          </el-table-column>
          <el-table-column align="center" prop="status" label="在库状态" width="150">
              <template slot-scope="scope">
                <div style="cursor: pointer;">
                  <template v-if="scope.row.status == 0||scope.row.status == 1||scope.row.status == 2">
                    <p class="state3" style="margin-top: 8px">
                      <span class="yuandian"></span>
                      <span>在库</span>
                    </p>
                  </template>
                  <template v-if="scope.row.status == 3">
                    <p class="state3" style="margin-top: 8px">
                      <span class="yuandian"></span>
                      <span>管理员取出</span>
                    </p>
                  </template>
                  <template v-if="scope.row.status == 4||scope.row.status == 6||scope.row.status == 5">
                    <p class="state2" style="margin-top: 8px">
                      <span class="yuandian"></span>
                      <span>借出</span>
                    </p>
                  </template>
                 
                
                </div>
              </template>
            </el-table-column>
          <el-table-column align="center" prop="states" label="状态" width="150">
            <template slot-scope="scope">
              <div @click="statesChange(scope.row)" style="cursor: pointer;">
                <template v-if="scope.row.states == 0">
                  <span class="state1">
                    <i class="iconfont icon-zhengchang"></i>
                    <span>正常</span>
                  </span>
                </template>
                <template v-if="scope.row.states == 1">
                  <span class="state3">
                    <i class="iconfont icon-jiangji"></i>
                    <span>降级</span>
                  </span>
                </template>
                <template v-if="scope.row.states == 2">
                  <span class="state2">
                    <i class="iconfont icon-tingyong_line"></i>
                    <span>停用</span>
                  </span>
                </template>
                <template v-if="scope.row.states == 3">
                  <span class="state2">
                    <i class="iconfont icon-weixiu"></i>
                    <span>需维修</span>
                  </span>
                </template>
                <template v-if="scope.row.states == 4">
                  <span class="state3">
                    <i class="iconfont icon-shebeijiandingshiyongren"></i>
                    <span>需检定</span>
                  </span>
                </template>
                <template v-if="scope.row.states == 5">
                  <span class="state3">
                    <i class="iconfont icon-icon"></i>
                    <span>需保养</span>
                  </span>
                </template>
                <template v-if="scope.row.states == 6">
                  <span class="state3">
                    <i class="iconfont icon-icon"></i>
                    <span>报废</span>
                  </span>
                </template>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="lastCalibrationTime" label="最近一次校准时间" show-overflow-tooltip width="160">
          </el-table-column>
          <el-table-column align="center" prop="calibrationMechanism" label="检定/校准机构" show-overflow-tooltip width="160">
          </el-table-column>
          <el-table-column align="center" prop="validityPeriod" label="检定/校准周期" show-overflow-tooltip width="160">
          </el-table-column>
          <el-table-column align="center" prop="borrower" label="借出人" show-overflow-tooltip width="120">
            <template slot-scope="scope">
              <template v-if="scope.row.borrower">
                {{scope.row.borrower}}
              </template>
              <template v-else>
                -
              </template>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="factoryName" label="厂家" show-overflow-tooltip width="150">
          </el-table-column>
          <el-table-column align="center" prop="isNeedPower" label="电量状况" width="150">
            <template slot-scope="scope">
              <template v-if="scope.row.isCharger">
                <template v-if="scope.row.isNeedPower == 0">
                  <span class="state1" style="color: #67C23A;" @click.stop="mandian">
                    <i class="iconfont icon-mandian"></i>
                  </span>
                </template>
                <template v-if="scope.row.isNeedPower == 1">
                  <span style="color: red;" class="state3" @click.stop="recharge(scope.row)">
                    <i class="iconfont icon-meidian"></i>
                  </span>
                </template>
              </template>
              <template v-else>
                <span></span>
              </template>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="produceTime" label="出厂日期" show-overflow-tooltip width="150">
          </el-table-column>
          <el-table-column align="center" prop="startUpTime" label="启用日期" show-overflow-tooltip width="150">
          </el-table-column>
          <el-table-column align="center" prop="purchaseTime" label="购买日期" show-overflow-tooltip width="150">
          </el-table-column>
          <el-table-column align="center" label="操作" fixed="right" width="180">
            <template slot-scope="scope">
              <el-button @click="showMode(scope.row)" type="text" size="small">详情</el-button>
              <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
              &nbsp;&nbsp;
              <el-dropdown>
                <span class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">
                    <span @click="exportClick(scope.row)">使用</span>
                  </el-dropdown-item>
                  <el-dropdown-item command="b">
                    <span @click="maintainClick(scope.row)">保养</span>
                  </el-dropdown-item>
                  <el-dropdown-item command="c">
                    <span @click="testClick(scope.row)">检定</span>
                  </el-dropdown-item>
                  <el-dropdown-item command="d">
                    <span @click="abnormalClick(scope.row)">异常</span>
                  </el-dropdown-item>
                  <el-dropdown-item command="e">
                    <span @click="outPut(scope.row)">出入库</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 详情弹框内容 -->
    <div class="popout model">
      <el-dialog title="详细信息" :visible.sync="dialogVisible" width="80%">
        <equip-model v-if="dialogVisible" :message="particular" @deleteItem="deleteItem"></equip-model>
      </el-dialog>
    </div>
    <!-- 编辑数据弹框 -->
    <div v-if="posp" class="popout model">
      <el-dialog title="修改数据" :visible.sync="posp" width="1000px" :modal-append-to-body="false" :close-on-click-modal="false">
        <redactModel :itemData="particular" @editingInstrument="editingInstrument" @cancel="cancel" type="update"></redactModel>
      </el-dialog>
    </div>
    <!-- 使用记录 -->
    <el-dialog title="仪器设备使用记录" center :visible.sync="exPosp" width="1350px"  append-to-body>
      <exportModel :exPosp="exPosp" :itemData="particular" :insId="particular.id"></exportModel>
    </el-dialog>

    <!-- 状态修改弹框 -->
    <el-dialog title="状态修改" v-if="sVisible" :visible.sync="sVisible" width="380px">
      <statue-model @statusOk="statusOk" @statusCancel="statusCancel" :status-modal="statusModal"></statue-model>
    </el-dialog>

    <!-- 检定弹框 -->
    <div>
      <el-dialog title="检定记录" :visible.sync="jdVisible" width="85%">
        <jd-table-pop-model :data-model="jdPopData" v-if="jdVisible"></jd-table-pop-model>
      </el-dialog>
    </div>
    <!-- 保养弹框 -->
      <el-dialog title="保养记录" center :visible.sync="byVisible" width="1450px">
        <by-table-pop-model :data-model="byPopData" v-if="byVisible"></by-table-pop-model>
      </el-dialog>
    <!-- 异常弹框 -->
    <div>
      <el-dialog title="" :visible.sync="abnormalVisible" width="1600px">
        <abnormal-pop-model :data-model="abnormalPopData" v-if="abnormalVisible"></abnormal-pop-model>
      </el-dialog>
    </div>
      <!-- 出入库记录弹框 -->
      <el-dialog title="出入库记录" center  :visible.sync="outPutVisible" width="1500px">
        <out-put-pop-model :data-model="outPutData" v-if="outPutVisible" />
      </el-dialog>
  </div>
</template>

<script>
import {
  ChangePowerStates,
  getVerify,
  getMainta,
  delectInstrument,
  changeStates,
  changeStatus,
  getInstrument,
  createInstrument,
} from "@/api/depotApi";
import equipModel from "../../components/equipModel";
import redactModel from "@/components/redactModel";
import statueModel from "../../components/statueModel";
import jdTablePopModel from "../../components/jdTablePopModel";
import exportModel from "../../components/exportModel";
import byTablePopModel from "../../components/byTablePopModel";
import outPutPopModel from "../../components/outPutPopModel.vue";
import abnormalPopModel from "@/components/abnormalPopModel";
export default {
  props: {
    dataList: Array,
    vStatus: Number,
    dLoading: Boolean,
  },
  name: "yqComponen",
  components: {
    equipModel,
    redactModel,
    exportModel,
    statueModel,
    byTablePopModel,
    jdTablePopModel,
    abnormalPopModel,
    outPutPopModel
  },
  data() {
    return {
      getRowKeys(row){
        return row.id
      },
      multipleSelection: [],
      addModel: false,
      dialogVisible: false,
      byVisible: false,
      jdVisible: false,
      // personList: [],
      particular: {}, //传给弹框数据
      posp: false, //编辑弹框
      exPosp: false, //导出弹框
      sVisible: false, //修改状态
      abnormalVisible: false, //异常状态
      outPutVisible: false,
      statusModal: {
        id: "",
        status: "",
      },
      outPutData :{},
      jdPopData: {}, //传参
      byPopData: {}, //传参
      abnormalPopData: {}, //传参
    };
  },
  created() {},
  computed: {
    personList() {
      return this.dataList;
    },
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val.map(it => it.id);
      this.$emit('update',this.multipleSelection)
    },
    clearMultipleSelection(){
      this.multipleSelection  = []
      this.$refs.multipleTable.clearSelection();
    },
    showMode(item) {
      this.particular = item;
      this.$store.dispatch("setInstrument", item);
      this.dialogVisible = true;
    },
    deleteItem(id) {
      let that = this;
      //删除数据
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delectInstrument({ id: id }).then((res) => {
            if (res.code == 200) {
              that.dialogVisible = false;
              that.$message({
                type: "success",
                message: "删除成功",
              });
              that.$emit("information", "dele");
            } else {
              this.$message.error(res.msg || "仪器删除失败！");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //分页功能
    pageChange(page) {
      this.currentPage = page;
      this.acquire();
    },
    /***充电状态时可点击改变成满电状态 */
    recharge(item) {
      ChangePowerStates({ insId: item.id }).then((res) => {
        this.$message({
          type: "success",
          message: "充电成功",
        });
        item.isNeedPower = 0;
      });
    },
    mandian() {},
    editClick(item) {
      getInstrument(item.id).then((res) => {
        if (res.code == 200 && res.data) {
          this.particular = res.data;
          this.posp = true;
        } else {
          this.$message.error(res.msg || "获取仪器信息失败！");
        }
      });
    },
    editingInstrument(data) {
      if(data=='cancel'){
        this.posp = false;
        return
      }
      let params = {
        ...data,
      };
      Object.keys(params).forEach((key) => {
        if (params[key] === "" || params[key] === null) {
          delete params[key];
        }
        if (key === "resultPicFile") {
          delete params[key];
        }
      });
      createInstrument(params)
        .then((res) => {
          if (res.code == "200") {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.$store.dispatch("setInstrument", res.data);
            this.$store.dispatch("setUpdateInstr", "true");
            this.posp = false;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("提交失败，请重新提交");
        });
    },
    cancel() {
      this.posp = false;
    },
    abnormalClick(item) {
      this.abnormalPopData = item;
      this.abnormalVisible = true;
    },
    maintainClick(item) {
      this.byPopData = item;
      this.byVisible = true;
    },
    testClick(item) {
      this.jdPopData = item;
      this.jdVisible = true;
    },
    outPut(item){
      this.outPutData = item;
      this.outPutVisible = true;
    },
    exportClick(val) {
      let self = this;
      self.particular = val;
      self.exPosp = true;
    },
    //修改出入库状态
    statusChange(val) {
      console.log(val,'123')
      let self = this;
      self.statusModal.id = val.id;
      self.$set(self.statusModal, "status", val.status);
      // self.statusModal.status = val.status;
      self.statusModal.type = "status";
      self.statusModal.stopTime=val.stopTime,
      self.statusModal.stopReason=val.stopReason,
      self.sVisible = true;
    },
    statusCancel() {
      this.sVisible = false;
    },
    statesChange(val) {
      let self = this;
      self.statusModal.id = val.id;
      self.$set(self.statusModal, "states", val.states);
      // self.statusModal.states = val.states;
      self.statusModal.stopTime=val.stopTime,
      self.statusModal.stopReason=val.stopReason,
      self.statusModal.type = "states";
      self.sVisible = true;
    },
    statusOk(data) {
      let self = this;
      if (self.statusModal.type == "status") {
        let data = {
          insId: self.statusModal.id,
          status: self.statusModal.status,
        };
        changeStatus(data).then((res) => {
          self.$message({
            type: "success",
            message: res.msg,
          });
          self.$emit("sChange", {});
        });
        // let userId =  this.$store.state.user.userInfo.id;
        // if(userId == 1){
        //
        // }else {
        //   self.$message({
        //     type: "success",
        //     message: "暂无更改权限！",
        //   });
        // }
      } else {
        changeStates({...data}).then((res) => {
          self.$message({
            type: "success",
            message: res.msg || "操作成功！",
          });
          self.$emit("sChange", {});
        });
      }
      self.sVisible = false;
    },
    byChange(operation, data) {
      if (operation) {
        getMainta(data).then((res) => {
          this.$message({
            message: "处理成功",
            type: "success",
          });
          this.mainIndex = 1;
          this.maintainList = [];
          this.$emit("information", "");
          this.byVisible = false;
        });
      } else {
        this.byVisible = false;
      }
    },
    jdChange(operation, data) {
      if (operation) {
        getVerify(data).then((res) => {
          if (res.code == "200") {
            this.$message({
              message: "处理成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
          this.verificaIndex = 1;
          this.verification = [];
          this.$emit("information", "");
          this.jdVisible = false;
        });
      } else {
        this.jdVisible = false;
      }
    },
  },
  watch: {},
};
</script>

<style lang='less' scoped>
@import "~@/assets/css/commonStyle.less";
@import "~@/assets/css/myTableStyle.less";
.yq-components {
  width: 100%;
  .content {
    // width: calc(100% - 170px);
    .card-list {
      width: 100%;
      margin-top: 10px;
      height: 740px;
      // display: flex;
      .yq-card-item {
        width: 32.3333%;
        float: left;
        box-sizing: border-box;
        margin-bottom: 10px;
        margin-left: 1%;
        height: 350px;
        border: 2px solid#0090F0;
        box-shadow: 0 0 33px#0090F0 inset;
        border-radius: 4px;
        .equip-item-top {
          width: 100%;
          height: 40%;
          background: linear-gradient(
            180deg,
            rgba(0, 210, 255, 0.52),
            rgba(0, 57, 142, 0.52)
          );
          .equip-imag {
            cursor: pointer;
            height: 100%;
            width: 100%;
            text-align: center;
          }
          .equip-detail {
            position: relative;
            .items {
              height: 30px;
              line-height: 30px;
              color: #74c8fe;
              /*line-height: 75%;*/
              font-size: 16px;
              margin-top: 10px;
              margin-left: 10px;
            }
            .items-hidden {
              width: 200px !important;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .tow-columns {
              display: flex;
              justify-content: space-between;
              color: #74c8fe;
              /*line-height: 75%;*/
              font-size: 16px;
              margin-top: 10px;
              margin-left: 10px;
              .left_item {
                width: 50%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .rigth_item {
                width: 50%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
            .iconf-letf {
              position: absolute;
              right: 10px;
              top: -0px;
              cursor: pointer;
              i {
                font-size: 24px;
                color: #74c8fe;
              }
            }
          }
        }
        .equip-item-bottom {
          width: 100%;
          height: 60%;
          background: rgba(8, 19, 41, 0.5);
          box-shadow: 0 0 15px #0071f1 inset;
          padding: 2% 4%;
          box-sizing: border-box;
          .row-item {
            color: #74c8fe;
            font-size: 16px;
            height: 38px;
            line-height: 38px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .left_item {
              display: inline-block;
              width: 30%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .rigth_item {
              display: inline-block;
             min-width: 220px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .left_item1 {
              display: inline-block;
              width: 70%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .right_item1 {
              display: inline-block;
              width: 28%;
              text-align: right;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .left_item2 {
              display: inline-block;
              width: 49%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .right_item2 {
              display: inline-block;
              width: 49%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .dibu {
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            i {
              margin-right: 4px;
            }
          }
        }
      }
      .add-item {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .resource-block {
      clear: both;
      text-align: center;
      margin-top: 30px;
    }
  }
}
/deep/ .el-dialog__body{
  padding-top: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Instrumentmanagemen/components/yq/yqcomponents.vue